var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#7f54b3" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6 46.9c-2.3-.2-6.7 1-8.7 10.8 0 5.9 1.4 9.5 3.6 10.8 4.1 1.2 8.9-4.3 8.9-10.2.2-4.1.4-9.2-3.8-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3 25.8H11.7C5.2 25.8 0 31 0 37.4v40c0 6.4 5.2 11.7 11.7 11.7h104.7c6.4 0 11.7-5.2 11.7-11.7v-40c-.1-6.4-5.3-11.6-11.8-11.6zM44 80s-6.9-9.1-8.5-16c-1.6-6.8-2-3.7-2-3.7S28 72.7 22.3 80.6s-8.5-3.9-8.5-3.9c-2-2.4-7.7-37.3-7.7-37.3 3.2-8.9 8.7-1.6 8.7-1.6l5.5 28.4s8.5-17.4 11.4-21.9c2.8-4.5 7.7-3.2 8.1 1.4.4 4.7 5.1 17.4 5.1 17.4.4-13.4 5.9-26.2 6.7-28.2.8-2 9.7-4.5 8.1 4.1-3.9 9.5-7.7 29.6-6.7 40.6-2.7 8.3-9 .4-9 .4zm35.9-4.5c-2.6 1.2-12.3 7.9-19.2-7.1C56.4 53.3 66 42.2 66 42.2s12.5-10.7 21 3.5c6.9 15.6-4.5 28.6-7.1 29.8zm31.8 0c-2.6 1.2-12.3 7.9-19.2-7.1-4.3-15.1 5.3-26.2 5.3-26.2s12.6-10.8 21.1 3.4c6.9 15.7-4.6 28.7-7.2 29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7 46.9c-2.3-.2-6.7 1-8.7 10.8 0 5.9 1.4 9.5 3.6 10.8 4.1 1.2 8.9-4.3 8.9-10.2.3-4.1.5-9.2-3.8-11.4zM61.3 89.1l22.3 13.1-4.7-13.1-12.8-3.6z"
  }));
};